import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0066FF',
      dark: '#0052CC',
      light: '#3385FF',
    },
    secondary: {
      main: '#6366F1',
    },
    text: {
      primary: '#1E293B',
      secondary: '#334155',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F8FAFC',
    },
    grey: {
      50: '#F8FAFC',
      100: '#F1F5F9',
      200: '#E2E8F0',
      300: '#CBD5E1',
      400: '#94A3B8',
      500: '#64748B',
      600: '#475569',
      700: '#334155',
      800: '#1E293B',
      900: '#0F172A',
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    button: {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '14px',
      letterSpacing: '-0.2px',
    },
  },
  shape: {
    borderRadius: 10,
  },
  shadows: [
    'none',
    '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    '0 4px 20px rgba(0, 0, 0, 0.08)',
    '0 8px 20px rgba(0, 102, 255, 0.35)',
    '0 4px 12px rgba(0, 102, 255, 0.25)',
    ...Array(16).fill('0 1px 2px 0 rgba(0, 0, 0, 0.05)'),
  ],
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 350,
      enteringScreen: 225,
      leavingScreen: 195,
    },
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(20px) saturate(180%)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '13px 28px',
          fontSize: '14px',
          fontWeight: 600,
          letterSpacing: '-0.2px',
          whiteSpace: 'nowrap',
          transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
          '@media (max-width: 768px)': {
            padding: '10px 20px',
            fontSize: '14px',
          },
          '@media (max-width: 480px)': {
            padding: '10px 18px',
            fontSize: '13px',
          },
        },
        contained: {
          boxShadow: '0 4px 12px rgba(0, 102, 255, 0.25)',
          background: 'linear-gradient(135deg, #0066FF 0%, #0052CC 100%)',
          '&:hover': {
            boxShadow: '0 8px 20px rgba(0, 102, 255, 0.35)',
            transform: 'translateY(-2px)',
            background: 'linear-gradient(135deg, #0066FF 0%, #0052CC 100%)',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#334155',
        },
      },
    },
  },
});

export default theme;
